<template>
    <el-dialog class="eval-dialog"
               :visible.sync="showSelectOrganDialog"
               title="确认注册足协"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="460px"
               center>
         <p class="organTitle">根据2019版《中国足球协会教练员培训管理规定》第三十五条要求，参加中国足协相关活动的教练员需要在中国足协的会员协会注册并接受管理，注册后一年之内不得修改。请认真选择并确认您要注册的会员协会：</p>
         <div class="form_content" >
            <el-form ref="form"  :model="form" :rules="rules"  class="form">
                <el-form-item label-width="90px" prop="organ" label="注册足协" >
                    <el-select v-model="form.organ" placeholder="请选择注册足协" filterable clearable prop="organ">
                        <el-option
                                v-for="item in organList"
                                :key="item.org_id"
                                :label="item.org_abbreviation"
                                :value="item.org_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="sure" >
                <el-button type="primary" @click="sure_select" :loading="loading" :disabled="loading">
                    确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {binding_org} from "../../api/ab_signup/api";
    export default {
        name: "select-organ",
        data(){
          return{
              form:{
                  organ:''
              },
              rules:{
                  organ: [
                      { required: true, message: '请选择注册足协', trigger: 'change' }
                  ],
              },
              loading:false
          }
        },
        props:{
            organList:{
                type:Array,
                required:true,
            },
            showdialog:{
                type:Boolean,
                required:true,
            }
        },
        methods:{
            sure_select(){
                this.loading=true;
                this.$refs['form'].validate(valid=>{
                    if (valid){
                        binding_org({
                            org_id:this.form.organ
                        }).then(res=>{
                            if (Number(res.data.status)===0){
                                this.loading=false;
                                this.$message.success('足协绑定成功');
                                this.$emit('hideTips',true)
                            }else{
                                this.$message.error(res.data.msg)
                                this.loading=false;
                            }
                        }).catch(err=>{
                            console.log(err);
                            this.loading=false;
                        })
                    }else{
                        this.$message.error('请选择注册足协');
                        this.loading=false
                    }
                })
            },
        },
        computed:{
            showSelectOrganDialog:{
                get(){
                    return this.showdialog;
                }
            }
        }
    }
</script>

<style scoped lang="stylus">
    .form_content
        padding-top: 50px
        .form
            padding-left: 30px
        .sure
            text-align: center;
            margin-top: 80px
</style>
